import { render, staticRenderFns } from "./input-button-scoring.vue?vue&type=template&id=5b8460b8&scoped=true"
import script from "./input-button-scoring.vue?vue&type=script&lang=js"
export * from "./input-button-scoring.vue?vue&type=script&lang=js"
import style0 from "./input-button-scoring.vue?vue&type=style&index=0&id=5b8460b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8460b8",
  null
  
)

export default component.exports